import { useMutation } from '@tanstack/react-query';
import { publishStudy } from '../domain/studies.api';
import logger from '@/core/services';
import { HttpError } from '@refinedev/core';

export const usePublishStudy = () => {
  const { mutate, isLoading } = useMutation({
    mutationFn: publishStudy,
    onError: (error: HttpError) => {
      logger.error('Error publishing study:', error);
    },
  });
  return { mutate, isLoading };
};
